import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy
} from "@angular/core";
import { Subscription } from "rxjs";
import {
  AddressSummary,
  AddressSummaryService
} from "../../../../../../../common/services/api/resources/addressSummary/address-summary.service";
import {
  AdvVoicemailboxWithExt,
  EmailOptions,
  VoicemailBasicInfo
} from "../../../admin-voicemail-types";
import { E2eLocators } from "@onsip/e2e/configs/locators";

@Component({
  selector: "onsip-admin-voicemail-basic-view",
  templateUrl: "./admin-voicemail-basic-view.component.html",
  styleUrls: ["../../admin-voicemail-shelf-container.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminVoicemailBasicViewComponent implements OnInit, OnDestroy {
  @Input() voicemail!: AdvVoicemailboxWithExt;
  @Input() lessThanMediumBreakpoint!: boolean;
  @Output() editPanel = new EventEmitter<void>();

  voicemailBasicInfo!: VoicemailBasicInfo;
  E2eLocators = E2eLocators;

  private listOfAddressSummary: Array<AddressSummary> = [];
  private unsubscriber = new Subscription();
  constructor(private addressSummaryService: AddressSummaryService) {}

  ngOnInit() {
    this.voicemailBasicInfo = {
      mailboxOwner: this.voicemail.voicemailboxOwner,
      mailboxName: this.voicemail.name,
      mailboxNumber: this.voicemail.mailbox,
      mailboxPin: this.voicemail.password,
      notificationEmail: this.voicemail.email,
      attachAsWav: this.voicemail.emailOptions.attach !== EmailOptions.NO,
      deleteAfterSending: this.voicemail.emailOptions.attach === EmailOptions.YES_THEN_DELETE,
      mwi: this.voicemail.mwi
    };

    this.unsubscriber.add(
      this.addressSummaryService.orgState.subscribe(addressSummary => {
        this.listOfAddressSummary = addressSummary;
      })
    );
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }

  getMwiDisplayName(): string {
    return (
      this.listOfAddressSummary.find(address => address.aor === this.voicemail.mwi)?.name || "n/a"
    );
  }

  getOwnerDisplayName(): string {
    return (
      this.listOfAddressSummary.find(
        address => address.aor === this.voicemailBasicInfo.mailboxOwner
      )?.name || "n/a"
    );
  }

  togglePanel(): void {
    this.editPanel.emit();
  }
}
